import { IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import ClearIcon from '@mui/icons-material/Clear';

function SelectPoste({ label, value, onChange, items, creneau1 = '', creneau2 = '' }) {
    const handleReset = () => {
        onChange({ target: { value: '' } }); // Simule un changement à une valeur vide
    }

    const isSelectDisabled = creneau1 || creneau2;

    return (
        <FormControl size="small" disabled={isSelectDisabled} sx={{ width: '100%' }}>
            <InputLabel>{label}</InputLabel>
            <Select
                value={value}
                label={label}
                onChange={onChange}
            >
                {items.map((item) => (
                    <MenuItem key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
            {value && ( // N'afficher la croix que si une valeur est sélectionnée
                <IconButton
                    aria-label="clear"
                    size="small"
                    onClick={handleReset}
                    style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}
                >
                    <ClearIcon />
                </IconButton>
            )}
        </FormControl>
    );
}

SelectPoste.propTypes = {
    label: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.any.isRequired,
    items: PropTypes.any.isRequired,
    creneau1: PropTypes.any,
    creneau2: PropTypes.any
};

export default SelectPoste;